import React, {Component} from "react";
import {connect} from "react-redux";

import * as loginActions from "../../actions/loginActions";

import SimpleFooter from "../../containers/global/SimpleFooter";
import NotificationPanel from "../../containers/apps/default/NotificationPanel";
import FramePanel from "../global/FramePanel";
import LoginForm from "../global/LoginForm";

class Login extends Component {
    render() {
        return (
            <div className="container-fluid content login bg-redlike" style={{WebkitAppRegion: "drag"}}>
                <FramePanel />
                <LoginForm logIn={this.props.dispatchLogInAction} />
                <NotificationPanel />
                <SimpleFooter virtualKeyboardSupport={true} />
            </div>
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchLogInAction: (login, password) => {
            dispatch(loginActions.logIn(login, password));
        }
    };
};

export default Login = connect(mapStoreToProps, mapDispatchToProps)(Login);
